// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__ezHwb","containerItemsCenter":"Skeleton_containerItemsCenter__1VmIq"};